import { ref } from 'vue'

export const HYDRO_THEME = 'HYDRO_THEME' as const
export const THEME_DARK = 'dark' as const
export const THEME_LIGHT = 'light' as const

type Theme = typeof THEME_DARK | typeof THEME_LIGHT

const isDarkMode = ref(false)

const applyTheme = (theme: Theme): void => {
    document.documentElement.setAttribute('data-theme', theme)
    localStorage.setItem(HYDRO_THEME, theme)
    isDarkMode.value = theme === THEME_DARK
}

const detectInitialTheme = (): Theme => {
    const storedTheme = localStorage.getItem(HYDRO_THEME)

    if (storedTheme === THEME_DARK || storedTheme === THEME_LIGHT) {
        return storedTheme
    }

    return window.matchMedia('(prefers-color-scheme: dark)').matches ? THEME_DARK : THEME_LIGHT
}

export const initializeTheme = (): void => {
    applyTheme(detectInitialTheme())
}

export const setDarkMode = (darkModeEnabled: boolean): void => {
    applyTheme(darkModeEnabled ? THEME_DARK : THEME_LIGHT)
}

export const useTheme = () => ({
    isDarkMode,
    setDarkMode,
})
